import { graphql } from 'react-relay';
import { type homepageDefaultRootQuery$variables } from './__generated__/homepageDefaultRootQuery.graphql.ts';

const homepageDefaultRootQuery = graphql`
    query homepageDefaultRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $fetchInitialHomepage: Boolean!
        $userType: String!
        $abTestList: [String] = []
        $isRemoveTopHeroBannerTestVariant: Boolean!
    ) {
        viewer {
            ...HpDefaultLayout_viewer
            ...isEmptyHomePage_viewer
            ...getHomePageMetaContent_viewer
        }
    }
`;

const homepageDefaultVariables: homepageDefaultRootQuery$variables = {
    fetchInitialHomepage: true,
    isMobile: false,
    homepageId: '',
    userType: '',
    isRemoveTopHeroBannerTestVariant: false,
};

export { homepageDefaultRootQuery, homepageDefaultVariables };
